import { render, staticRenderFns } from "./PaymentHistory.vue?vue&type=template&id=96919a66&"
import script from "./PaymentHistory.vue?vue&type=script&lang=ts&"
export * from "./PaymentHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports